<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    class="menu-class"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        :label="$t('fields.range')"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        readonly
        clearable
        @click.clear="dates=[]"
        @keydown.escape="dates=[]"
        class="picker-class"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="dates"
      range
      no-title
      scrollable
      :locale="$i18n.locale"
      :max="$moment().toISOString()"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="dates=[],menu = false">
        <i18n path="button.cancel" />
      </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(dates)">
        <i18n path="button.apply" />
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateRange",
  props: {
    value: {
      type: Array,
      required: true
    },
  },
  watch: {
    dates() {
      this.$emit("input", this.dates);
    }
  },
  computed: {
    dateRangeText: {
      get() {
        return this.dates.join(" ~ ");
      },
      set() {
        return;
      }
    }
  },
  data() {
    return {
      dates: [],
      menu: false
    };
  }
};
</script>

<style>
</style>